/**
 * A wrong URL is almost always a stale bookmark or a typo, so this offers the
 * way back rather than apologizing.
 */

import { Link } from 'react-router-dom';
import { PageHeader } from '../components/AppShell';
import { Button, EmptyState } from '../components/ui';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Not found" />
      <div className="card">
        <EmptyState
          title="There is nothing at this address"
          body="The link may be out of date."
          action={
            <Link to="/">
              <Button emphasis="primary">Go to the overview</Button>
            </Link>
          }
        />
      </div>
    </>
  );
}
